import {screenSizes} from '#breakpoints';
import {useOnceEffect} from '#hook';
import {useDebounce} from '#hook/useDebounce';

/**
 * This hook returns an object containing the height and width values for the
 * current size of the viewport. If the user resizes the browser window, it will
 * return updated values. These values are debounced to avoid unnecessarily
 * frequent updates.
 */
export function useViewportSize() {
  const [height, setHeight] = useDebounce<number>(0, 100);
  const [width, setWidth] = useDebounce<number>(0, 100);
  const isMobile = width < screenSizes.medium;
  const isTablet = width >= screenSizes.medium && width < screenSizes.large;
  const isDesktop = width >= screenSizes.large;

  const handleResize = (): void => {
    setHeight(window.innerHeight);
    setWidth(window.innerWidth);
  };

  useOnceEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => window.removeEventListener('resize', handleResize);
  });

  return {
    height,
    width,
    isMobile,
    isTablet,
    isDesktop,
  };
}
